import { MyProfileLayout } from "./MyProfileLayout";
export default MyProfileLayout;
